import React, { useContext, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { observer, useLocalStore } from 'mobx-react';
import { globalInfoStoreContext } from '@/models/global';
import { ReactComponent as Logo } from '@/assets/logo.svg';
import styles from './index.module.scss';
import {
  MenuItems,
  JoinOpenSceneUrlMap,
  HeaderMenuByOpenScene,
} from '@/const';
import { useTranslation } from 'react-i18next';
import Search from '../Search';
import SelectMore from '@/component/SelectMore';
import UserAvatar from '@/component/UserAvatar';
import { getQueryParams } from '@/utils/common';

interface Props{
  pathname?: string;
  children?: JSX.Element;
}

const GlobalHeader: React.FC<Props> = ({ pathname = '', children }) => {
  const globalStore = useContext(globalInfoStoreContext);
  const { openSceneList } = globalStore;
  const history = useHistory();
  const { t } = useTranslation();

  const State = useLocalStore(() => ({
    isShowMenu: false,
    isShowScene: false,
    isShowSearch: false,
  }));

  const Jump = useCallback((url) => {
    const id = getQueryParams('openscene_id');
    window.location.href = `${url}?openscene_id=${id}`;
  }, []);

  useEffect(() => {
    if (openSceneList.length && !JoinOpenSceneUrlMap.includes(pathname)) {
      State.isShowMenu = true;
      State.isShowScene = true;
    } else {
      State.isShowMenu = false;
      State.isShowScene = false;
    }
  }, [openSceneList, pathname]);

  return (
    <div className={styles.header}>
      <div className={styles.logo} onClick={() => history.push('/')}>
        <Logo width={100} height={36} />
        <div className={styles.logoText}>
          {t('scene_manager')}
        </div>
      </div>

      {/* 开放场景 */}
      {State.isShowScene && (
        <SelectMore
          type="scene"
          list={openSceneList}
        />
      )}

      {/* menu */}
      <div className={styles.menus}>
        {State.isShowMenu && HeaderMenuByOpenScene.map((item: MenuItems) => (
          <div
            key={item.key}
            onClick={() => { Jump(item.redirect); }}
            className={`${styles.item} ${(item.path?.includes(pathname) || pathname.includes(item.key)) && styles.active}`}
          >
            {t(item.name)}
            <span />
          </div>
        ))}
      </div>

      { children }
      {/* 搜索功能 */}
      {State.isShowSearch && (
      <>
        <Search />
        <div className={styles.line} />
      </>
      )}
      {/* 用户信息 */}
      <UserAvatar />
    </div>
  );
};

export default React.memo(observer(GlobalHeader));
